
import { SearchTravelResult } from '@/types/models'
import { LocaleStrings } from '@/types/paramModels';
import { computed, defineComponent, PropType, ref } from 'vue'
import { useStore } from 'vuex';

export default defineComponent({
    name: "TravelArticle",
    props: {
        travel: {
            type: Object as PropType<SearchTravelResult>,
            required: true
        },
        pageTexts: {
            type: Object,
            required: true
        },
        localeStrings: {
            type: Object as PropType<LocaleStrings>,
            required: true
        }
    },
    setup(_props) {
        const store = useStore();

        const paramString = '#/hotel?searchKey=' + store.state.TravelSearchResponseModule.searchTravelResponse.searchKey + '&flightsSearchKey=' + _props.travel.flightsSearchKey + '&hotelsSearchKey=' + _props.travel.hotelsSearchKey + '&hotelCode=' + _props.travel.hotelCode;

        const priceInTotal = computed(() => {
            return _props.pageTexts['hotelListPageSearchResultLabelFromPrice'].replace(/\[[price\]]+\]/g, _props.travel.cheapestPrice.toLocaleString(_props.localeStrings.longName)).replace(/\[[currency\]]+\]/g, _props.travel.currency);
        });

        const pricePerPerson = computed(() => {
            return _props.pageTexts['hotelListPageSearchResultLabelPricePerPerson'].replace(/\[[price\]]+\]/g, _props.travel.cheapestPricePerPerson.toLocaleString(_props.localeStrings.longName)).replace(/\[[currency\]]+\]/g, _props.travel.currency);
        });

        const travelTags = computed(() => {
            if(_props.travel.tags.length)
                return JSON.parse ( JSON.stringify ( _props.travel.tags) );

            return [];
        });

        const shuffledTags = computed(() => {
                return travelTags.value.sort((a, b) => 0.5 - Math.random());
        });

        return {
            paramString,
            priceInTotal,
            pricePerPerson,
            shuffledTags
        }
    },
})
